module.exports = function (el) {
    var $el = $(el);
    var href = $el.attr('href');
    var id = $el.data('popupModalId');
    var modalClass = $el.data('popupModalClass');
    var cookieExpiration = $el.data('popupModalHideForDaysAfterDismissal');

    if (!modalClass) {
        modalClass = 'popup-modal';
    }

    var secondsElapsed = $el.data('popupModalTimeElapsed') * 1000;
    var secondsOnSite = $el.data('popupModalTimeToElapse') * 1000;

    var modalTrigger = $el.modaal({
        content_source: href,
        type: 'inline',
        overlay_opacity: .8,
        custom_class: modalClass,
        after_open: function (modal_wrapper) {
            ICF.Modules.PopupModal.RegisterPopupCTAEvents(modal_wrapper, id, $el, cookieExpiration);
            require('./trigger-datalayer-event')($el, 'Time on Site');
        },
        before_close: function() {
            ICF.Modules.PopupModal.SetPopupCookie(id, cookieExpiration);
        }
    });

    if (secondsOnSite > secondsElapsed) {
        var secondsRemaining = secondsOnSite - secondsElapsed;

        setTimeout(function () {
            modalTrigger.modaal('open');
        }, secondsRemaining);
    }
    else {
        modalTrigger.modaal('open');
    }
};